import CN from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../../components/Button";
import ImageUpload, { Image } from "./plugins/ImageUpload";
import { useSelector } from "react-redux";
import store from "../../store/store";
import { Oval } from "react-loader-spinner";
import { addOffer } from "../Offers/reducer/offerSlice";

interface FormValues {
  active: boolean;
  name: string;
  type: string;
  expireDate: string;
  discountPercentage: number;
  sendEmail: boolean;
}

export const AddOffer: React.FC<any> = () => {
  const { isLoading } = useSelector((state: any) => state.rootReducer?.brand);
  const navigate = useNavigate();

  // Validation schema
  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Offer Name is required")
      .max(50, "Offer Name must be 50 characters or less"),
    type: Yup.string(),
    expireDate: Yup.date().required("Date is required"),
    discountPercentage: Yup.number()
      .required("Percentage is required")
      .min(1, "Percentage must be greater than or equal to 1"),
    // images: Yup.array().min(1, "At least one image is required"),
    // logo: Yup.array(),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    errors,
    touched,
  } = useFormik<FormValues>({
    initialValues: {
      active: true,
      name: "",
      type: "percentage-discount",
      expireDate: "",
      discountPercentage: 0,
      sendEmail: false,
    },
    validationSchema,
    onSubmit: (values: FormValues) => {
      const data = {
        active: values.active, // Convert string to boolean
        name: values.name,
        type: values.type,
        expireDate: values.expireDate,
        discountPercentage: Number(values.discountPercentage), // Convert string to number
        issendEmail: values.sendEmail,
      };

      // console.log("formData", formData);
      // const data = {
      //   active: true,
      //   name: "offer 2",
      //   type: "percentage-discount",
      //   expireDate: "2025-12-12 15:30:45",
      //   discountPercentage: 100,
      // };

      // addProductContext?.addNewProduct(formData);
      store.dispatch(addOffer(data));
    },
  });

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <form onSubmit={handleSubmit}>
        <div className="lg:grid grid-cols-2 flex flex-col gap-6 my-4 py-8 lg:mx-8 mx-4">
          {/* Brand Name */}
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Offer Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Offer Name"
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.name && touched.name
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.name && touched.name && (
              <p className="text-red-500 text-sm my-2">{errors.name}</p>
            )}
          </div>

          {/* Description */}
          <div className="col-span-1">
            <div className="flex flex-col gap-1 mb-2">
              <label className="block text-base font-semibold">
                Expire Date
              </label>
            </div>
            <input
              type="date"
              name="expireDate"
              // value={values.expireDate}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Expire Date"
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.expireDate && touched.expireDate
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {/* {errors.expireDate && touched.expireDate && (
              <p className="text-red-500 text-sm my-2">{errors.expireDate}</p>
            )} */}
          </div>

          <div className="col-span-1">
            <div className="flex flex-col gap-1 mb-2">
              <label className="block text-base font-semibold">Offers</label>
            </div>
            <select
              name="type"
              // value={values.type}
              // onChange={handleChange}
              // onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.type && touched.type
                  ? "border-red-500"
                  : "border-primary1"
              )}
            >
              <option>Discount</option>
            </select>
            {errors.type && touched.type && (
              <p className="text-red-500 text-sm my-2">{errors.type}</p>
            )}
          </div>

          {/* country Name */}
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Discount Percentage (%)
            </label>
            <input
              type="text"
              name="discountPercentage"
              value={values.discountPercentage}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Brand country"
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.discountPercentage && touched.discountPercentage
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.discountPercentage && touched.discountPercentage && (
              <p className="text-red-500 text-sm my-2">
                {errors.discountPercentage}
              </p>
            )}
          </div>
          {/* Popular Product */}
          <div className="col-span-2 flex items-start">
            <input
              type="checkbox"
              name="sendEmail"
              className="accent-primary1 w-[18px] h-[18px] mr-3 my-1 cursor-pointer rounded border border-primary1"
              onChange={(e) => setFieldValue("sendEmail", e.target.checked)}
              checked={values.sendEmail}
            />
            <div className="flex flex-col gap-1 mb-2">
              <label className="block text-base font-semibold">
                Send Email
              </label>
              <span className="font-normal text-sm">
                Send all subsciber an email
              </span>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div
          className={`flex justify-end flex-row gap-4 mt-5 py-4 w-full sticky bottom-0 bg-primary2 lg:px-8 px-4`}
        >
          <div className="col-span-2 flex justify-end gap-5">
            <Button onClick={() => navigate("/offers")} apparence="gray">
              Cancel
            </Button>

            <Button isLoading={isLoading.brandAdd} view="default" type="submit">
              <div className="flex gap-1">
                {isLoading.brandAdd && (
                  <Oval
                    height={18}
                    width={18}
                    color="#ffff"
                    wrapperStyle={{}}
                    wrapperClass="max-sm:mt-[3.5px] mt-[5.2px] max-lg:mt-[5.2px]"
                    visible={true}
                    ariaLabel="oval-loading"
                    secondaryColor="gray-primary"
                    strokeWidth={6}
                    strokeWidthSecondary={6}
                  />
                )}
                <div className="font-normal text-base">Save</div>
              </div>
            </Button>
          </div>
        </div>
      </form>
    </motion.div>
  );
};

export default AddOffer;
